import cn from "classnames"
import { RenderBardWithComponents } from "components/Wysiwyg"
import { DynamicHeadline } from "components/DynamicHeadline"
import Image from "components/Image"
import Section, { parseColors } from "components/Section"
import Letter from "components/ui/Letter"
import LinkButton from "components/ui/LinkButton"
import styles from "../TextMedia.module.scss"

const TextImage = ({ data = {}, colors, content, isCta }) => {
  const {
    textImageText: text,
    image,
    image_orientation,
    letter: letterObj,
    link: url,
    link_text: linkText,
    new_tab: newTab,
    headline_teaser: headlineTeaser,
    dynamic_headline: headline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    text_image_fill_background: fillBg,
    image_background_color,
    ankerslug,
  } = data

  const imageBackgroundColor = image_background_color || "#40454A"

  const { accent, background } = parseColors({ colors, fillBg })

  const letter = letterObj?.value || "v"
  const hasImage = !!image
  const hasLetter = letterObj && letter !== "none"
  const hasGraphic = hasImage
  const hasBg = fillBg && background.color !== "transparent"
  const graphicRight = image_orientation?.value === "right"

  const noBgColor = !hasBg || background.color === "transparent"

  return (
    <Section
      id={ankerslug}
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      className={cn(styles.textMediaWrapper, {
        [styles.filled]: hasBg,
        [styles.letterOnly]: hasLetter && !hasImage,
        [styles.mediaOnly]: !hasLetter && hasImage,
        [styles.noGraphic]: !hasGraphic,
        [styles[`textMediaWrapper--${content.locale}`]]: content.locale,
      })}
      data={data}
      colors={colors}
    >
      {headline && headlineTeaser && (
        <p className={styles.headlineTeaser}>{headlineTeaser}</p>
      )}
      <DynamicHeadline
        headlineType={headlineType.value}
        headlineAppearance={headlineAppearance.value}
      >
        {headline}
      </DynamicHeadline>
      <div
        className={cn(styles.textMedia, {
          [styles.flexReverse]: hasGraphic && graphicRight,
        })}
      >
        <div className={styles.graphicWrapper}>
          {hasLetter && (
            <Letter
              type={letter}
              fill={accent.color}
              className={cn(styles.letter, {
                [styles.letterLeft]: !graphicRight,
                [styles.letterRight]: graphicRight,
                [styles.letterReverse]: hasLetter && graphicRight,
              })}
            />
          )}
          {hasImage && (
            <div
              className={cn(styles.mediaWrapper, {
                "rounded-tl-design": false,
                "rounded-tr-design": false,
                "rounded-bl-design": false,
                "rounded-br-design": true,
              })}
            >
              <Image
                src={image.permalink}
                alt={image.alt}
                width={image.width}
                height={image.height}
                sizes="(max-width: 767px) 100vw, 50vw"
                style={{
                  objectPosition: image?.focus_css,
                  backgroundColor:
                    content.locale !== "digital" && imageBackgroundColor,
                }}
              />
            </div>
          )}
        </div>
        <div className={styles.contentWrapper}>
          {!headline && headlineTeaser && (
            <p className={styles.headlineTeaser}>{headlineTeaser}</p>
          )}
          <div className={styles.text}>
            <RenderBardWithComponents content={text} prefix="text_" />
          </div>
          {url && (
            <LinkButton
              className={cn(styles.button, {
                [styles.ctaLink]: isCta,
                "button--cta-alt": noBgColor,
                "button--cta": !noBgColor,
              })}
              data={{
                link_url: url,
                link_text: linkText,
                link_blank: newTab,
              }}
            />
          )}
        </div>
      </div>
    </Section>
  )
}

export default TextImage
